/* Dogs Supreme — PDP Gallery 2026 (2026-06-13 v4: visibility-aware thumb centering, kein Klick-Jerk (CDN-refresh))
 * Apple-Style Galerie-Verbesserungen OHNE Eingriff in den Theme-Slider-Kern.
 *
 * Aufgaben:
 *  - Hover-Pfeile (Desktop) -> Flickity previous()/next()
 *  - Bildzaehler "N / total" synchron zum aktiven Slide
 *  - Aktiven Thumbnail sauber im Scroller zentrieren (ersetzt das grobe
 *    scrollLeft = elLeft - 100 des Themes durch echte Zentrierung)
 *  - Re-Bind nach Breakpoint-Re-Init (matchSmall / unmatchSmall)
 *
 * Greift NICHT in theme.js ein. Liest nur die vorhandene Flickity-Instanz
 * via Flickity.data(el). Defensiv: tut nichts, wenn etwas fehlt.
 */
(function () {
  'use strict';

  var DEBUG = /[?&]ds_debug=1/.test(location.search);
  function log() {
    if (!DEBUG) return;
    console.log.apply(console, ['[DS-Gallery2026]'].concat([].slice.call(arguments)));
  }

  function getFlickity(el) {
    if (!el || !window.Flickity || !window.Flickity.data) return null;
    return window.Flickity.data(el);
  }

  // Eigene rAF-Scroll-Animation: natives smooth-scrollTo wird durch die
  // dauerhaft laufenden AOS-Transitions der Seite abgebrochen und kommt
  // nie an. Diese Animation ist deterministisch und nur durch einen
  // neueren Aufruf auf demselben Element ersetzbar.
  function animateScrollLeft(el, target, duration) {
    if (el._dsScrollAnim) cancelAnimationFrame(el._dsScrollAnim);
    var start = el.scrollLeft;
    var delta = target - start;
    if (Math.abs(delta) < 1) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.scrollLeft = target;
      return;
    }
    var t0 = performance.now();
    function step(now) {
      var p = Math.min(1, (now - t0) / duration);
      var eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
      el.scrollLeft = start + delta * eased;
      if (p < 1) {
        el._dsScrollAnim = requestAnimationFrame(step);
      } else {
        el._dsScrollAnim = null;
      }
    }
    el._dsScrollAnim = requestAnimationFrame(step);
  }

  // Aktiven Thumbnail innerhalb des Scrollers zentrieren (nur horizontaler
  // Scroll im Container, NIE die Seite scrollen).
  function centerActiveThumb(wrapper, index) {
    var photos = wrapper.closest('.product__photos');
    var thumbsRoot = photos ? photos.querySelector('[data-product-thumbs]') : null;
    if (!thumbsRoot) return;
    var scroller = thumbsRoot.querySelector('[data-product-thumbs-scroller]');
    if (!scroller) return;
    var thumb = scroller.querySelector('.product__thumb-item[data-index="' + index + '"]');
    if (!thumb) return;

    // Rect-Differenz statt offsetLeft: unabhaengig davon, welcher Vorfahre
    // gerade offsetParent ist (AOS-Transforms aendern das).
    var tr = thumb.getBoundingClientRect();
    var sr = scroller.getBoundingClientRect();
    // NUR scrollen, wenn der aktive Thumbnail NICHT bereits vollstaendig sichtbar ist.
    // Klick auf einen sichtbaren Thumb -> keine Bewegung (kein "links-dann-rechts"-Jerk).
    // Wischen/Pfeil/Variante zu einem Off-Screen-Thumb -> sanft zentrieren.
    if (tr.left >= sr.left - 1 && tr.right <= sr.right + 1) return;
    var target = scroller.scrollLeft + (tr.left - sr.left) - (sr.width - tr.width) / 2;
    var maxScroll = scroller.scrollWidth - scroller.clientWidth;
    if (target < 0) target = 0;
    if (target > maxScroll) target = maxScroll;

    animateScrollLeft(scroller, target, 350);
  }

  function updateCounter(wrapper, index) {
    var cur = wrapper.querySelector('[data-ds-gallery-current]');
    if (cur) cur.textContent = String(index + 1);

    // Kurzes Aufblitzen des Zaehlers als Feedback (Desktop ohne Hover).
    var counter = wrapper.querySelector('[data-ds-gallery-counter]');
    if (counter) {
      counter.classList.add('is-visible');
      clearTimeout(counter._dsHideTimer);
      counter._dsHideTimer = setTimeout(function () {
        counter.classList.remove('is-visible');
      }, 1200);
    }
  }

  function bindWrapper(wrapper) {
    var el = wrapper.querySelector('[data-product-photos]');
    if (!el) return false;

    var flkty = getFlickity(el);
    if (!flkty) return false;

    // Pfeile (Click-Handler holen die Instanz frisch -> ueberlebt Re-Init)
    if (!wrapper._dsArrowsBound) {
      var prev = wrapper.querySelector('[data-ds-gallery-prev]');
      var next = wrapper.querySelector('[data-ds-gallery-next]');
      if (prev) {
        prev.addEventListener('click', function (e) {
          e.preventDefault();
          var f = getFlickity(el);
          if (f) f.previous();
        });
      }
      if (next) {
        next.addEventListener('click', function (e) {
          e.preventDefault();
          var f = getFlickity(el);
          if (f) f.next();
        });
      }
      wrapper._dsArrowsBound = true;
    }

    // Select-Handler an die AKTUELLE Instanz binden (Re-Init -> neue Instanz).
    if (!flkty._dsSelectBound) {
      var center = function () {
        var i = flkty.selectedIndex;
        // Delay: NACH dem Theme-eigenen childNavGoTo (scrollLeft = elLeft-100)
        // laufen, damit unsere Zentrierung der letzte Scroll-Befehl ist.
        setTimeout(function () { centerActiveThumb(wrapper, i); }, 120);
      };
      flkty.on('select', function () {
        updateCounter(wrapper, flkty.selectedIndex);
        center();
      });
      // 'settle' feuert im Fade-Modus nicht zuverlaessig, schadet aber nicht:
      // animateScrollLeft bricht aeltere Animationen selbst ab.
      flkty.on('settle', center);
      flkty._dsSelectBound = true;
      // Initialzustand setzen
      updateCounter(wrapper, flkty.selectedIndex || 0);
    }

    log('bound wrapper', { cells: flkty.cells.length, selected: flkty.selectedIndex });
    return true;
  }

  // Mit Polling auf die (asynchron initialisierte) Flickity-Instanz warten.
  function bindWrapperWithRetry(wrapper, attempts) {
    if (bindWrapper(wrapper)) return;
    if (attempts <= 0) {
      log('giving up on wrapper after retries');
      return;
    }
    setTimeout(function () { bindWrapperWithRetry(wrapper, attempts - 1); }, 150);
  }

  function bindAll() {
    var wrappers = document.querySelectorAll('.product__main-photos-wrapper');
    for (var i = 0; i < wrappers.length; i++) {
      bindWrapperWithRetry(wrappers[i], 20); // ~3s
    }
  }

  function init() {
    bindAll();
    // Theme re-initialisiert den Slider bei Breakpoint-Wechsel -> neu binden.
    document.addEventListener('matchSmall', function () { setTimeout(bindAll, 300); });
    document.addEventListener('unmatchSmall', function () { setTimeout(bindAll, 300); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
